import {FormSelectOptionsT} from '@/lib/types/form.types';

export const cannabinoidUnits: FormSelectOptionsT[] = [
  {value: 'mg', label: 'Milligram'},
  {value: 'g', label: 'Gram'},
  {value: 'kg', label: 'Kilogram'},
  {value: 'ml', label: 'Milliliter'},
  {value: 'oz', label: 'Ounce'},
  {value: 'lb', label: 'Pound'},
  {value: 'gallon', label: 'Gallon'},
  {value: 'liter', label: 'Liter'},
  {value: 'percentage', label: 'Percentage'},
];
